import { FIELD_BIND_TYPE_ENUM } from '@constants'
import { CommandParameterDTO, CommandParametersType } from '@types'

import { getTypeIdUpper, isConfiguredParameter, trim } from './isConfiguredParameter'

export const getDataFromState = (
  data: CommandParametersType[] | undefined
): CommandParameterDTO[] => {
  if (!data?.length) return []

  const seenTitleIds = new Set<string>()

  return data
    .filter(param => param.title?.id != null)
    .filter(isConfiguredParameter)
    .filter(param => {
      const key = String(param.title?.id)
      if (seenTitleIds.has(key)) return false
      seenTitleIds.add(key)

      return true
    })
    .map(param => {
      const typeId = getTypeIdUpper(param)

      return {
        id: param.id,
        title: String(param.title?.id ?? ''),
        type: String(param.type?.id ?? ''),
        objectCode: param.objectCode?.id == null ? null : String(param.objectCode.id),
        objectTitle: String(param.objectCode?.label ?? ''),
        value: trim(param.value),
        pathArray: typeId === FIELD_BIND_TYPE_ENUM.FIELD ? param.pathArray : null,
      }
    })
}
